import { Component, OnDestroy, OnInit } from '@angular/core';
import { VendorService } from 'src/app/_services/vendor.services';
import { LoaderService } from 'src/app/loader.service';
import { SnackbarService } from '../../_service/message-service';
import { Role } from 'src/app/util/enums/role.enum';
import { Subscription } from 'rxjs';
import { TableBtn, TableColumn } from 'src/app/shared/interfaces';
import { ExportCSVService } from 'src/app/_services/export-csv.service';
import { TranslateService } from '@ngx-translate/core';
import { GeneralDialogComponent } from 'src/app/shared/components/general-dialog/general-dialog.component';
import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { UserInfoService } from 'src/app/_services/userInfo.service';
import { MenuRouteID } from '../header/menu-item/nav-item';
import { AuthenticationService } from 'src/app/_services';
import { RouteConstants } from 'src/app/util/route.constants';
import { BreadcrumbService } from '../breadcrumb/breadcrumb.service';
import { NotificationService } from 'src/app/_services/notification.service.v2';

export interface alertData {
  chargebox_id: string;
  connector_id: number;
  errorCode: string;
  info: string;
  status: string;
  date: string;
  time: string;
}
@Component({
  selector: 'telio-alerts-ans-notification',
  templateUrl: './alerts-ans-notification.component.html',
  styleUrls: ['./alerts-ans-notification.component.scss']
})
export class AlertsAnsNotificationComponent implements OnInit, OnDestroy {
  columns: TableColumn[];
  buttons: TableBtn[];
  actionHeader: string = '';
  filterPlaceholder: string = '';
  subscriptions = new Subscription();
  initialData: any;
  userDetails: any = {};
  notificationsArry: alertData[]
  vendormailid: any;
  count: any;
  index;
  rows;
  totalSearchCount;
  deleteid: any
  connectorID: any;
  stnid: any = {};
  pageList = {
    currentPage: 0,
    pageSize: 10
  };
  currentPage = 0;
  totalDataCount = 0;
  sortColumn = '';
  sortDirection = 'asc';

  constructor(
    private vendorservice: VendorService,
    private userInfoService: UserInfoService,
    public loaderService: LoaderService,
    readonly exportCSVService: ExportCSVService,
    public translate: TranslateService,
    readonly breadcrumbService: BreadcrumbService,
    private toastr: SnackbarService,
    readonly route: ActivatedRoute,
    private notificationService:NotificationService,
    private authenticationService: AuthenticationService,
    readonly dialog: MatDialog, private router: Router,) {
    this.userDetails = this.userInfoService.userDetails;
    this.getNotificationcount();
    this.updateNotifications();
    this.vendormailid = this.userDetails.email;
    this.rerender(this.pageList, '');
    this.columns = [
      { columnDef: 'chargeboxId', header: 'alertNotification.stationID', cell: (element: alertData) => `${element.chargebox_id}`, sortingDisabled: false, width: '100px', isLink: this.userInfoService.isTabExists(+this.route.snapshot.paramMap.get('routeID')) },
      { columnDef: 'connectorId', header: 'alertNotification.connectorID', cell: (element: alertData) => `${element.connector_id}`, sortingDisabled: false, width: '100px' },
      { columnDef: 'errorCode', header: 'alertNotification.errorCode', cell: (element: alertData) => `${element.errorCode}`, sortingDisabled: false, width: '100px' },
      { columnDef: 'info', header: 'alertNotification.info', cell: (element: alertData) => `${element.info}`, sortingDisabled: true, width: '100px' },
      { columnDef: 'status', header: 'alertNotification.status', cell: (element: alertData) => `${element.status}`, sortingDisabled: true, width: '100px', caseSensitive: 'uppercase' },
      { columnDef: 'timestamp', header: 'alertNotification.date', cell: (element: alertData) => `${element.date}`, sortingDisabled: true, width: '100px' },
      { columnDef: 'time', header: 'alertNotification.time', cell: (element: alertData) => `${element.time}`, sortingDisabled: true, width: '100px' }
    ];
    this.buttons = [
    ];
    this.filterPlaceholder = 'generalTable.filterPlaceholder';
    this.actionHeader = 'alertNotification.actions';
  }

  ngOnInit() {
  }

  rerender(value: any, searchFilter?: string) {
    this.getAllAlerts(value, searchFilter) 
  }

  actionClick() {
    this.rerender(this.pageList);
  }

  actionCSV() {
    const options = {
      filename: this.translate.instant('alertNotification.title'),
      showTitle: false,
      title: this.translate.instant('alertNotification.title'),
      useKeysAsHeaders: true,
    }
      this.subscriptions.add(this.notificationService.getAlertAndNotification(1, this.totalDataCount, this.sortColumn, 'asc', '').subscribe((resp: any) => {
        this.initialData = resp.content;
        this.setAlertsMap(this.initialData);
        this.initialData.forEach((item: any) => delete item.timestamp);
        this.exportCSVService.exportCSV(options, this.initialData);
      }))
  }

  getAllAlerts(value: any, searchFilter: string = '') {
    this.subscriptions.add(this.notificationService.getAlertAndNotification(value.currentPage + 1, value.pageSize, this.sortColumn, this.sortDirection, searchFilter).subscribe((resp: any) => {
      this.notificationsArry = resp.content;
      this.totalDataCount = resp.total_items;
      this.setAlertsMap(this.notificationsArry)
    }))
  }

  // To get Alert Notification by Vendor ID
  getAlertAndNotificationbyvendorid(value: any, vendormailid?: any, searchFilter: string = '') {
    this.subscriptions.add(this.notificationService.getAlertAndNotification(value.currentPage + 1, value.pageSize, this.sortColumn, this.sortDirection, searchFilter).subscribe((resp: any) => {
      this.notificationsArry = resp.content;
      this.totalDataCount = resp.total_items;
      this.setAlertsMap(this.notificationsArry)
    }))
  }

  dateTransformCreatedDate(date: string) {
    let dateIn: Date = new Date(date);
    dateIn.setHours(dateIn.getHours() + 5);
    dateIn.setMinutes(dateIn.getMinutes() + 30);
    let dateOut = dateIn.toISOString().replace("T", " ").substring(0, 10);
    return dateOut;
  }

  buttonClick(result: string[]) {
    let tempArray = result[1].split(',')
    this.connectorID = tempArray[1]
    this.deleteid = tempArray[0]
    this.deleteFeature();
  }

  deletenotificationvendorbyid() {
    this.notificationService.deletenotificationvendorbyid(this.deleteid, this.connectorID).subscribe(
      (resp: any) => {
        if (!!resp) {
          this.toastr.info(resp);
          this.rerender(this.pageList)
        }
        else {
          this.toastr.error(resp)
        }
      });
  }

  getNotificationcount() {
    var temp = this.userDetails.userId
    this.notificationService.getNotificationcount(temp).subscribe(
      (data) => {
        this.count = data;
        this.notificationService.getInfoNotificationCount(temp).subscribe(
          (data) => {
          }
        )
      });
  }

  updateNotifications() {
    var temp = this.authenticationService.getEmail();
    this.notificationService.updatenotification(temp).subscribe(
      (data) => {
      }
    )
  }

  loadData(value: any) {
    let val = {
      currentPage: value.currentPage,
      pageSize: value.pageSize
    }
    this.pageList.pageSize = value.pageSize;
    this.rerender(val, '')
  }

  sortClick(event: any) {
    this.sortColumn = event.active;
    this.sortDirection = event.direction;
    this.rerender(this.pageList, '');
  }

  applyFilter(filteredData: string) {
    this.rerender(this.pageList, filteredData)
  }

  deleteFeature(): void {
    let dialogRef = this.dialog.open(GeneralDialogComponent, {
      width: '50vw',
      height: '200px',
      data: { component: ConfirmDialogComponent, button: this.translate.instant('faq.confirmButton'), title: this.translate.instant('createStation.confiration'), otherbtn: this.translate.instant('faq.confirmNo'), message: this.translate.instant('alertNotification.confirmDelete') }
    }).afterClosed().subscribe(res => {
      if (res && res == 'Yes') {
        this.deletenotificationvendorbyid();
      }
    });
  }

  ngOnDestroy() {
    this.subscriptions && this.subscriptions.unsubscribe();
  }

  stndetails(stndata) {
    this.stnid = stndata.chargebox_id;
    this.router.navigate(['/dashboard/stations/details', { routeID: MenuRouteID.STATIONS }], { queryParams: { "stationid": JSON.stringify(this.stnid), routedName: 'alertnnotification' } })
    this.breadcrumbService.emitBreadCrumbs(RouteConstants.ALERT_NOTIFICATION_STATION);
  }

  linkClick(event) {
    if (event.column.columnDef == "chargeboxId") {
      this.stndetails(event.row);
    }
  }

  setAlertsMap(data) {
    data.map((item: any, id: number) => {
      let empty = 'NA';
      item.chargebox_id = !item.chargebox_id ? empty : item.chargebox_id
      item.connector_id = !item.connector_id ? empty : item.connector_id
      item.errorCode = !item.error_code ? empty : item.error_code
      item.status = !item.status ? empty : item.status
      item.info = !item.info ? empty : item.info
      // item.date = !item.timestamp ? empty : this.dateTransformCreatedDate(item.timestamp)
      item.date = !item.timestamp ? empty :this.authenticationService.convertToLocalTime(item.timestamp, this.userInfoService.userDetails.prefCountry).split(' ')[0];
      // item.time = !item.timestamp ? empty : this.authenticationService.convert24HrTo12Hr(item.timestamp).slice(11, 19)
      item.time = !item.timestamp ? empty : this.authenticationService.convert24HrTo12Hr(this.authenticationService.convertToLocalTime(item.timestamp, this.userInfoService.userDetails.prefCountry)).slice(11, 19);
    });
  }
}


